/* global Swiper */
// *******************************************************************************
// 1.0 - Category List
// *******************************************************************************

const categoryListSliderElements = document.querySelectorAll('[data-slider="category-list-slider"]');

const categoryListSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 22,
  watchOverflow: true,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  speed: 600,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1240: {
      slidesPerView: 3,
      spaceBetween: 65,
    },
  },
};

categoryListSliderElements.forEach((el) => {
  const categoryListSliderParent = el.closest('.sc-category-list');
  const arrowRight = categoryListSliderParent.querySelector('.arrow-right');
  const arrowLeft = categoryListSliderParent.querySelector('.arrow-left');

  categoryListSliderOptions.navigation.nextEl = arrowRight;
  categoryListSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-new
  new Swiper(el, categoryListSliderOptions);
});
